
<button type="button" #matMenuTrigger mat-raised-button color="{{buttonColor}}" 
  [matMenuTriggerFor]="menu"
  [matTooltip]="displayToolTip()"
  (menuOpened)="onMenuOpened()" 
  (menuClosed)="onMenuClosed()">{{triggerButtonText}}<mat-icon>menu</mat-icon></button>

  <mat-menu #menu="matMenu" [class]="menuClass">
  <mat-checkbox #menuItems *ngFor="let item of options; let i = index;" [(ngModel)]="item.activated"
    (click)="$event.stopPropagation()" (change)="onOptionSelect()" (keydown)="onMenuKeyDown($event, i)">{{ item.title
    }}</mat-checkbox>
</mat-menu>

